import { OrderTotal } from "./price-entity/price-condition-bounded.types";
import moment from "moment-timezone";
import { BooleanCondition, type ConditionalDateRangeCondition } from "./price-entity/price-condition.types";
import { OrderLevelDiscount, ProductLevelDiscount } from "./discount.types";
import type { IPromotionsStack } from "../interfaces/promotionsPage";

export interface BaseRequestOptions {
    id: string;
    enabled: boolean;
    merchant_id: string;
    name: string;
    description: string;
    company_ids: string[];
    customer_group_ids: string[];
    sku_ids?: string[];
    category_ids?: string[];
    product_ids?: string[];
    boolean_condition?: BooleanCondition;
    order_total?: OrderTotal;
    promotionActiveStartDate: moment.Moment;
    promotionActiveEndDate: moment.Moment | null;
    pricingStartDate?: moment.Moment;
    pricingEndDate?: moment.Moment;
    isLineItemLevel: boolean;
    isEditMode: boolean;
    entityId?: string;
    created_by: string;
    promotionStackingConfig: IPromotionsStack;
    netTermsExtension?: number;
}

export interface PromotionOptions extends BaseRequestOptions {
    isThreshold: boolean;
    selectedDiscounts: (OrderLevelDiscount | ProductLevelDiscount)[];
    currencies: string[];
    amountOf: number;
    upperBoundExclusive?: string;
    lowerBoundInclusive?: string;
    created_by: string;
}

export interface PriceConditionOptions {
    currencies?: string[];
    company_ids?: string[];
    customer_group_ids?: string[];
    sku_ids?: string[];
    product_ids?: string[];
    category_ids?: string[];
    boolean_condition?: BooleanCondition;
    order_total?: OrderTotal;
    upperBoundExclusive?: string;
    lowerBoundInclusive?: string;
    conditional_date_range_condition?: ConditionalDateRangeCondition;
    shipped_amount_condition?: OrderTotal;
}

export interface PriceActionOptions {
    amount: number;
    isThreshold: boolean;
    isLineItemLevel?: boolean;
    priceActionId: string;
    messages?: string[];
    isQty?: boolean;
    netTermsExtension?: number;
}

export enum PriceActionType {
    // text after | should be uniq (can generate UUID)
    DISCOUNT = "discounts|",
    THRESHOLD = "threshold|",
    SHIPPING = "discounts|shipping|",
}

export interface CreatePromotionResult {
    isError: boolean;
    errorMessage?: string;
}
